<template>
  <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" v-bind="layout">
    <a-form-model-item  label="规格名" prop="guigeming">
      <a-input v-model="ruleForm.guigeming" type="text" autocomplete="off" />
    </a-form-model-item>

    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="submitForm('ruleForm')"> 保存 </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>

export default {
  data() {
    return {
      ruleForm: {
        guigeming: '',
      },
      rules: {
        guigeming: [{ required: true, message: '规格名不能为空', trigger: 'change' }],
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
      },
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
       console.log("valid",this.ruleForm.guigeming)
     this.$emit("my-event",this.ruleForm.guigeming)

   
        } else {
          return false
        }
      })
    },
  },
}
</script>
